import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "speaker",
  "use": "speaker-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"speaker\">\n    <path d=\"M7.622.711L3.455 4.878A.417.417 0 0 1 3.161 5H.833A.833.833 0 0 0 0 5.833v3.334c0 .46.373.833.833.833h2.328c.11 0 .216.044.294.122l4.167 4.167a.417.417 0 0 0 .711-.295V1.006A.417.417 0 0 0 7.622.71zM10 1.667v1.666c1.898.388 3.333 2.155 3.333 4.167S11.898 11.28 10 11.667v1.666c2.822-.407 5-2.9 5-5.833 0-2.933-2.178-5.426-5-5.833zM10 5v5c.938-.26 1.667-1.27 1.667-2.5S10.937 5.322 10 5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol